import type React from "react";

export interface StatSkeletonProps {
  widthClass?: string;
  heightClass?: string;
  className?: string;
}

// Simple reusable skeleton block for stat tiles
export const StatSkeleton: React.FC<StatSkeletonProps> = ({
  widthClass = "w-16",
  heightClass = "h-10",
  className = "",
}) => {
  return (
    <div
      className={`${heightClass} ${widthClass} bg-gray-200 rounded animate-pulse ${className}`}
    />
  );
};
